import React, { useState, useEffect } from 'react';
import { Download, Eye } from 'lucide-react';
import { getApiBaseUrl } from '../config/backend.config';

function ImageThumbnail({ file, fileId, workspaceId, getAuthToken, onView, onDownload }) {
  const [presignedUrl, setPresignedUrl] = useState(null);
  const [error, setError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const fetchUrl = async () => {
      if (!workspaceId || !getAuthToken || !file.s3_key) return;

      try {
        const token = await getAuthToken();
        if (!token || cancelled) return;

        const apiBaseUrl = getApiBaseUrl();
        const queryParams = new URLSearchParams({
          s3_key: file.s3_key,
          workspace_id: workspaceId
        }).toString();

        const response = await fetch(`${apiBaseUrl}/files/presigned-url?${queryParams}`, {
          method: 'GET',
          headers: { 'Authorization': `Bearer ${token}` }
        });

        if (!response.ok) throw new Error('Failed to get presigned URL');

        const data = await response.json();
        if (!cancelled) {
          setPresignedUrl(data.file_url);
        }
      } catch (err) {
        console.error('Error fetching thumbnail URL:', err);
        if (!cancelled) {
          setError(true);
        }
      }
    };

    fetchUrl();
    return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file.s3_key, workspaceId]);

  const handleView = async (e) => {
    e.stopPropagation();
    if (presignedUrl) {
      onView(presignedUrl, file.filename, file.file_type, file.file_size);
    }
  };

  const handleDownload = async (e) => {
    e.stopPropagation();
    if (presignedUrl) {
      window.open(presignedUrl, '_blank');
    }
  };

  if (error) {
    return null;
  }

  return (
    <div className="image-thumbnail-container" onClick={handleView}>
      {(!imageLoaded) && (
        <div className="image-thumbnail-shimmer" />
      )}
      {presignedUrl && (
        <img
          src={presignedUrl}
          alt={file.filename}
          className={`image-thumbnail ${imageLoaded ? 'loaded' : ''}`}
          onLoad={() => setImageLoaded(true)}
          onError={() => setError(true)}
        />
      )}
      {imageLoaded && (
        <div className="image-thumbnail-overlay">
          <button
            onClick={handleView}
            className="image-thumbnail-btn"
            title="View"
          >
            <Eye size={14} />
          </button>
          <button
            onClick={handleDownload}
            className="image-thumbnail-btn"
            title="Download"
          >
            <Download size={14} />
          </button>
        </div>
      )}
      {imageLoaded && (
        <div className="image-thumbnail-filename">
          {file.filename}
        </div>
      )}
    </div>
  );
}

export default ImageThumbnail;
